<soft-page>
  <soft-page-header>
    <div>
      <p class="soft-title">Kassearbeitsplatz verbinden</p>
      <p class="text-sm text-light">Bitte füllen Sie das Formular aus</p>
    </div>
  </soft-page-header>
  <div class="w-full mt-3">
    <p class="soft-label top block mb-2">Name</p>
    <soft-field-ok
      fieldOkName="kasse"
      placeholder="Kassa auswählen"
      [(value)]="workstation"
    />
  </div>

  @if (properties().length > 0) {
    <div class="w-full mt-6">
      <p class="soft-label top block mb-2">Eigenschaften</p>
      <ul class="flex flex-col divide-y border rounded">
        @for (property of properties(); track property.key) {
          <li class="flex items-center justify-between px-3 py-2">
            <span class="text-sm">{{ property.key }}</span>
            @if (property.isBoolean) {
              <soft-ds-switch
                [value]="property.checked"
                (valueChange)="toggle(property.key, $event)"
              />
            } @else {
              <span class="text-sm font-semibold">{{ property.value }}</span>
            }
          </li>
        }
      </ul>
    </div>
  }
</soft-page>
